export const pegawais = [
  {
    ID: 1,
    NamaPegawai: "Pegawai 1",
    Cabang: "Pusat",
    Bagian: "Litbang",
    SubBagian: "TI",
    Jabatan: "Kasubag",
    Golongan: "C1",
    StatusPegawai: "Pegawai Tetap",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Hindu",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 2,
    NamaPegawai: "Pegawai 2",
    Cabang: "Lovina",
    Bagian: "Litbang",
    SubBagian: "TI",
    Jabatan: "Kasubag",
    Golongan: "C1",
    StatusPegawai: "Pegawai Tetap",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Hindu",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 3,
    NamaPegawai: "Pegawai 3",
    Cabang: "Pusat",
    Bagian: "Produksi",
    SubBagian: "TI",
    Jabatan: "Staf",
    Golongan: "A1",
    StatusPegawai: "Kontrak",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Hindu",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 4,
    NamaPegawai: "Pegawai 4",
    Cabang: "Lovina",
    Bagian: "Produksi",
    SubBagian: "TI",
    Jabatan: "Staf",
    Golongan: "A1",
    StatusPegawai: "Kontrak",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Hindu",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 5,
    NamaPegawai: "Pegawai 5",
    Cabang: "Seririt",
    Bagian: "Distribusi",
    SubBagian: "TI",
    Jabatan: "Kabag",
    Golongan: "A1",
    StatusPegawai: "Pegawai Tetap",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Hindu",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 6,
    NamaPegawai: "Pegawai 6",
    Cabang: "Seririt",
    Bagian: "Distribusi",
    SubBagian: "TI",
    Jabatan: "Kabag",
    Golongan: "C1",
    StatusPegawai: "Training",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Hindu",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 7,
    NamaPegawai: "Pegawai 7",
    Cabang: "Pancasari",
    Bagian: "Akuntansi",
    SubBagian: "TI",
    Jabatan: "Staf",
    Golongan: "B1",
    StatusPegawai: "Training",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Hindu",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 8,
    NamaPegawai: "Pegawai 8",
    Cabang: "Pancasari",
    Bagian: "Akuntansi",
    SubBagian: "TI",
    Jabatan: "Staf",
    Golongan: "B1",
    StatusPegawai: "Pegawai Tetap",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Islam",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 9,
    NamaPegawai: "Pegawai 9",
    Cabang: "Busungbiu",
    Bagian: "Keuangan",
    SubBagian: "TI",
    Jabatan: "Kasubag",
    Golongan: "C1",
    StatusPegawai: "Pegawai Tetap",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Islam",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 10,
    NamaPegawai: "Pegawai 10",
    Cabang: "Busungbiu",
    Bagian: "Litbang",
    SubBagian: "TI",
    Jabatan: "Kasubag",
    Golongan: "C1",
    StatusPegawai: "Pegawai Tetap",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Islam",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 11,
    NamaPegawai: "Pegawai 11",
    Cabang: "Pusat",
    Bagian: "Keuangan",
    SubBagian: "TI",
    Jabatan: "Kasubag",
    Golongan: "C1",
    StatusPegawai: "Pegawai Tetap",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Buddha",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
  {
    ID: 12,
    NamaPegawai: "Pegawai 12",
    Cabang: "Pusat",
    Bagian: "Litbang",
    SubBagian: "TI",
    Jabatan: "Kasubag",
    Golongan: "C1",
    StatusPegawai: "Pegawai Tetap",
    TglMasuk: "2020-01-01",
    TglKeluar: "",
    TglPensiun: "",
    TempatLahir: "Denpasar",
    TglLahir: "1990-09-13",
    Alamat: "Singaraja",
    Telp: "080989999",
    Agama: "Buddha",
    JenisKelamin: "",
    StatusPerkawinan: "",
  },
];
